export default class MassiaSelectController {
	/* @ngInject */
	constructor($scope, $state, $stateParams, MassiaSelectService, notification, $location, $translate, SharedDataService, $attrs, $timeout) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.MassiaSelectService = MassiaSelectService;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$attrs = $attrs;
		this.$timeout = $timeout;
		this.searchText = '';
		this.name = this.$attrs.name;
		this.filteredOptions = [];
		this.displayLimit = 20;
		this.messageError = '';
		this.error = false;
		this.datalinks = [];
		this.highlightedIndex = -1;
	}

	transformData(input) {
		const output = input.map((item) => ({
			id: item.id,
			value: item.code + ' | ' + item.libelle
		}));
		return output;
	}

	transformDataSite(input) {
		const output = input.map((item) => ({
			id: item.id,
			value: item.libelle
		}));
		return output;
	}

	transformDataBenneTracteur(input) {
		const output = input.map((item) => ({
			id: item.id,
			value: item.im
		}));
		return output;
	}

	transformDataVehicule(input) {
		const output = input
			.filter((item) => item.immatTracteur !== null || item.immatTracteur !== null)
			.map((item) => ({
				id: item.id,
				value: item.immatTracteur + (item.immatBenne != null ? ' - ' + item.immatBenne + ' ' + '[' + item.nomTypeBenne + ']' : '')
			}));
		return output;
	}

	transformDataChauffeur(input) {
		const output = input
			.filter((item) => item.nom !== null || item.prenom !== null)
			.map((item) => ({
				id: item.id,
				value: item.code + ' : ' + item.nom + ' ' + item.prenom
			}));
		return output;
	}

	transformDataFournisseur(input) {
		const output = input.map((item) => ({
			id: item.id,
			value: item.code + ' : ' + item.libelle
		}));
		return output;
	}

	transformDataProduit(input) {
		const output = input.map((item) => ({
			id: item.id + '_' + item.producteurId,
			value: item.code + ' : ' + item.libelle
		}));
		return output;
	}

	clearInput() {
		this.searchText = '';
		this.filterOptions();
	}

	// Ajuste automatiquement le défilement de la liste des propositions
	async scrollToHighlighted() {
		// Référence à l'élément en surbrillance
		var optionContainer = document.querySelector('#list_' + this.name);
		var highlightedOption = optionContainer.querySelector('li.selected');

		if (highlightedOption) {
			highlightedOption.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest'
			});
		}
	}

	handleKeyDown(event) {
		switch (event.keyCode) {
			case 40: // Flèche du bas
				if (this.highlightedIndex < this.filteredOptions.length - 1) {
					this.highlightedIndex++;

					this.$timeout(this.scrollToHighlighted.bind(this), 0);
				}
				break;
			case 38: // Flèche du haut
				if (this.highlightedIndex > 0) {
					this.highlightedIndex--;
					this.$timeout(this.scrollToHighlighted.bind(this), 0);
				}
				break;
			case 13: // Touche Entrée
			case 9: // Touche Tab
				event.preventDefault();
				if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredOptions.length) {
					this.selectOption(this.filteredOptions[this.highlightedIndex]);
				}
				this.highlightedIndex = -1;
				this.focusNextField(); // Passer au champ suivant
				break;
		}
	}

	focusNextField() {
		// Trouve l'élément d'entrée suivant
		const formElements = document.querySelectorAll('input, select, textarea, button, [tabindex]');
		const currentElement = document.activeElement;
		let nextElement = null;
		// Recherche l'élément suivant dans le DOM
		for (let i = 0; i < formElements.length; i++) {
			if (formElements[i] === currentElement) {
				for (let j = i + 1; j < formElements.length; j++) {
					if (!formElements[j].disabled && formElements[j].offsetParent !== null) {
						nextElement = formElements[j];
						break;
					}
				}
				break;
			}
		}

		if (nextElement) {
			nextElement.focus();
		}
	}

	async $onInit() {
		this.options = [];
		this.isEditMode = false;

		var dataObject = {
			value: String(this.ngModel),
			messageType: '',
			message: ''
		};

		this.SharedDataService.setData(this.name, dataObject);

		if (this.config.datalink) {
			this.datalinks = this.config.datalink.includes(',')
				? this.config.datalink
						.replace(/[[\]]/g, '')
						.split(',')
						.map((datalink) => datalink.trim())
				: [this.config.datalink];

			// Watch
			this.$scope.$watchGroup(
				this.datalinks.map((datalink) => () => this.SharedDataService.getData(datalink).value),
				async (newValues, oldValues) => {
					let ignoreCheck = false;
					// console.log("-------------------------------------------------------------------------------------------------------------");
					// console.log("--------------------------------------------------------------------------------------------------------------watchGroup (1)" + this.name);
					// console.log("--------------------------------------------------------------------------------------------------------------datalink (1)", this.datalinks);
					// console.log("-------------------------------------------------------------------------------------------------------------- (oldValues)", oldValues);
					// console.log("-------------------------------------------------------------------------------------------------------------- (newValues)", newValues);
					if (oldValues[0] == '' || oldValues[0] == 'undefined' || oldValues[0] == '0') {
						if (newValues[0] == '' || newValues[0] == 'undefined' || newValues[0] == '0') {
							ignoreCheck = true;
						}
					}

					if (!ignoreCheck && !angular.equals(newValues, oldValues)) {
						if (this.ngTimeout != null) {
							clearTimeout(this.ngTimeout);
							this.ngTimeout = null;
						}
						//console.log("- Difference detect -----------------------------------------------------------------------------------------(datatype)", this.config.datatype);

						if (this.config.datatype === 'site') {
							this.reinitSelect('site');

							await this.loadSite(newValues);
						}
						if (this.config.datatype === 'sites') {
							this.reinitSelect('sites');
							await this.loadSites(newValues);
						}
						if (this.config.datatype === 'siteTransporteur') {
							this.reinitSelect('siteTransporteur');

							await this.loadSitesTransporteur(newValues);
						}
						if (this.config.datatype === 'benne') {
							this.reinitSelect('benne');

							await this.loadBennes(newValues);
						}
						if (this.config.datatype === 'vehicule') {
							this.reinitSelect('vehicule');

							await this.loadVehicules(newValues);
						}
						if (this.config.datatype === 'transporteur') {
							this.reinitSelect('transporteur');

							await this.loadTransporteurs(newValues);
						}
						if (this.config.datatype === 'chauffeur') {
							this.reinitSelect('chauffeur');

							await this.loadChauffeurs(newValues);
						}
						if (this.config.datatype === 'fournisseur') {
							this.reinitSelect('fournisseur');

							await this.loadFournisseurs(newValues);
						}
						if (this.config.datatype === 'provenance') {
							this.reinitSelect('provenance');

							await this.loadProvenances(newValues);
						}
						if (this.config.datatype === 'commande') {
							this.reinitSelect('commande');

							await this.loadCommandes(newValues);
						}
						if (this.config.datatype === 'produit') {
							this.reinitSelect('produit');

							const societe = this.SharedDataService.getData('societe').value;
							const site = this.SharedDataService.getData('site').value;

							await this.loadProduits(site, societe);
						}
						if (this.config.datatype === 'client') {
							this.reinitSelect('client');

							const societe = this.SharedDataService.getData('societe').value;

							await this.loadClients(societe);
						}

						this.filterOptions(true, false, () => this.checkNgModel());
					}
					//console.log("-------------------------------------------------------------------------------------------------------------- (Fin)");
				}
			);
		}
		this.waitForVariables(async () => {
			if (this.config && this.options.length == 0 && !this.loadingData) {
				if (this.config.datatype == 'societe') {
					await this.loadSociete();
				} else if (this.config.datatype == 'site') {
					//Commercial
					await this.loadSite();
				} else if (this.config.datatype == 'sites') {
					//all
					await this.loadSites();
				} else if (this.config.datatype == 'benne') {
					await this.loadBennes();
				} else if (this.config.datatype == 'tracteur') {
					await this.loadTracteurs();
				} else if (this.config.datatype == 'vehicule') {
					await this.loadVehicules();
				} else if (this.config.datatype == 'transporteur') {
					await this.loadTransporteurs();
				} else if (this.config.datatype == 'chauffeur') {
					await this.loadChauffeurs();
				} else if (this.config.datatype == 'fournisseur') {
					await this.loadFournisseurs();
				} else if (this.config.datatype == 'provenance') {
					await this.loadProvenances();
				} else if (this.config.datatype == 'commande') {
					await this.loadCommandes();
				} else if (this.config.datatype == 'produit') {
					await this.loadProduits();
				} else if (this.config.datatype == 'client') {
					await this.loadClients();
				} else if (this.config.datatype == 'siteTransporteur') {
					await this.loadSitesTransporteur();
				}
				this.checkNgModel();
			}

			// Écoute des changements spécifiques via SharedDataService
			this.SharedDataService.listenData(this.name, this.verifyForm.bind(this));
		});
	}

	waitForVariables(callback) {
		if (typeof this.ngModel === 'undefined') {
			this.ngTimeout = setTimeout(() => {
				this.waitForVariables(callback);
			}, 50);
		} else {
			if (callback != null) callback();
		}
	}

	startLoadingData() {
		this.loadingData = true;
		this.placeholder = 'Chargement en cours...';
	}

	endLoadingData() {
		this.loadingData = false;
	}

	reinitSelect(objetName) {
		var dataObject = {
			value: '',
			messageType: '',
			message: ''
		};
		this.SharedDataService.setData(objetName, dataObject);
	}

	verifyForm(newValueObject) {
		this.error = false;
		if (newValueObject.messageType === 'error') {
			this.error = true;
			this.messageError = newValueObject.message;
		}

		if (this.ngModel != '' && (newValueObject.value == '' || newValueObject.value == '0')) {
			this.ngModel = 0;
			this.searchText = '';
		}
	}

	idIsConformToDatalink(id) {
		if (id == '' || typeof id === 'undefined' || id == '0') {
			if (this.config.datalinkOptional == null && this.datalinks.length > 0) {
				this.placeholder = 'En attente du champ ' + this.datalinks[0];
				return false;
			}
		}
		return true;
	}

	checkNgModel() {
		if (this.ngModel) {
			const opt = this.options.find((o) => o.id == this.ngModel);
			if (opt) {
				this.selectOption(opt);
			} else {
				this.ngModel = 0;
			}
		}
	}

	async loadSociete() {
		this.startLoadingData();
		var ret = await this.MassiaSelectService.getSocietesCom();
		this.endLoadingData();
		this.options = this.transformData(ret);
		if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection de la société';
		else this.placeholder = 'Aucune donnée';
	}

	async loadSite(id) {
		if (!this.idIsConformToDatalink(id)) return;

		this.startLoadingData();
		this.loadingId = id;
		var ret = await this.MassiaSelectService.getSitesCom(id);
		if (id == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataSite(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du site commercial';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadSites(id) {
		if (!this.idIsConformToDatalink(id)) return;

		this.startLoadingData();
		this.loadingId = id;
		var ret = await this.MassiaSelectService.getSites(id);
		if (id == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataSite(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du site';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadSitesTransporteur(id) {
		if (!this.idIsConformToDatalink(id)) return;

		this.startLoadingData();
		this.loadingId = id;
		var ret = await this.MassiaSelectService.getSitesTransporteur(id);
		if (id == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataSite(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du site transporteur';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadClients(idSociete) {
		if (!this.idIsConformToDatalink(idSociete)) return;

		this.startLoadingData();
		this.loadingId = idSociete;
		var ret = await this.MassiaSelectService.getClients(idSociete);
		if (idSociete == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformData(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du client';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadTracteurs() {
		this.startLoadingData();
		var ret = await this.MassiaSelectService.getTracteurs();
		this.endLoadingData();
		this.options = this.transformDataBenneTracteur(ret);
		if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du tracteur';
		else this.placeholder = 'Aucune donnée';
	}

	async loadBennes(id) {
		if (!this.idIsConformToDatalink(id)) return;

		this.startLoadingData();
		this.loadingId = id;
		var ret = await this.MassiaSelectService.getBennes(id);
		if (id == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataBenneTracteur(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection de la benne';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadVehicules(idSite) {
		if (!this.idIsConformToDatalink(idSite)) return;

		this.startLoadingData();
		this.loadingId = idSite;
		var ret = await this.MassiaSelectService.getVehicules();
		if (idSite == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataVehicule(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du vehicule';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadTransporteurs(idSite) {
		if (!this.idIsConformToDatalink(idSite)) return;

		this.startLoadingData();
		this.loadingId = idSite;
		var ret = await this.MassiaSelectService.getTransporteurs(idSite);
		if (idSite == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataSite(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du transporteur';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadChauffeurs(idTransporteur) {
		if (!this.idIsConformToDatalink(idTransporteur)) return;

		this.startLoadingData();
		this.loadingId = idTransporteur;
		var ret = await this.MassiaSelectService.getChauffeurs(idTransporteur);
		if (idTransporteur == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataChauffeur(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du chauffeur';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadFournisseurs(idSite) {
		if (!this.idIsConformToDatalink(idSite)) return;

		this.startLoadingData();
		this.loadingId = idSite;
		var ret = await this.MassiaSelectService.getFournisseurs(idSite);
		if (idSite == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataFournisseur(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du fournisseur';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadProvenances(idFournisseur) {
		if (!this.idIsConformToDatalink(idFournisseur)) return;

		this.startLoadingData();
		this.loadingId = idFournisseur;
		var ret = await this.MassiaSelectService.getProvenances(idFournisseur);
		if (idFournisseur == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataFournisseur(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection de la provenance';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadCommandes(idProvenance) {
		if (!this.idIsConformToDatalink(idProvenance)) return;

		this.startLoadingData();
		this.loadingId = idProvenance;
		var ret = await this.MassiaSelectService.getCommandes(idProvenance);
		if (idProvenance == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataFournisseur(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection de la commande';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	async loadProduits(siteCommercialId) {
		if (!this.idIsConformToDatalink(siteCommercialId)) return;

		this.startLoadingData();
		this.loadingId = siteCommercialId;
		var ret = await this.MassiaSelectService.getProduits(siteCommercialId);
		if (siteCommercialId == this.loadingId) {
			this.endLoadingData();
			this.options = this.transformDataProduit(ret);
			if (this.options != null && this.options.length > 0) this.placeholder = 'Sélection du produit';
			else this.placeholder = 'Aucune donnée';
		} else {
			//Une autre requête a été lancée pendant l'await on ignore celle-là
		}
	}

	$onDestroy() {
		// Nettoyage si nécessaire
	}

	filterOptions(resetDisplayLimit = true, resetNgModel = true, callbackAction = null) {
		if (resetDisplayLimit) this.displayLimit = 20;
		// console.log("-------------------------------------------------------------------------------------------------------------------------------------------");
		// console.log("filterOptions "+ this.name);
		// console.log("-------------------------------------------------------------------------------------------------------------------------------------------");
		if (resetNgModel) {
			this.ngModel = 0;
		}

		var dataObject = {
			value: String(this.ngModel),
			messageType: '',
			message: ''
		};

		this.SharedDataService.setData(this.name, dataObject);

		// Initialisez options et searchText si elles sont nulles ou indéfinies
		this.options = this.options || [];
		this.searchText = this.searchText || '';

		// Temporisation de 300ms
		this.$timeout(() => {
			if (this.searchText.length > 0) {
				this.filteredOptions = this.options
					.filter((option) => option.value.toLowerCase().includes(this.searchText.toLowerCase()))
					.slice(0, this.displayLimit);
			} else {
				this.filteredOptions = this.options.slice(0, this.displayLimit);
			}
			if (callbackAction != null) {
				callbackAction();
			}
		}, 300);
	}

	loadMoreOptions() {
		this.displayLimit += 100;
		this.filterOptions(false);
		if (this.unfocusTimeout) {
			clearTimeout(this.unfocusTimeout);
			this.unfocusTimeout = null;
		}

		//On garde la popup de sélection ouverte
		const elemName = 'list_' + this.name + '_input';
		const element = document.getElementById(elemName);
		if (element) {
			element.focus({
				preventScroll: true
			});
			this.isFocused = true;
		}
	}

	reset() {
		this.ngModel = '0';
		this.searchText = '';
		this.options = [];
	}

	// Fonction executée si declaré dans la balise exemple : on-select="$ctrl.handleSelect(selected)">
	selectOption(option) {
		if (this.onSelect) {
			this.onSelect({ selected: option });
		} else {
			console.log('onSelect is not defined');
		}
		this.ngModel = String(option.id);
		this.searchText = option.value;
		this.isFocused = false;

		var dataObject = {
			value: String(this.ngModel),
			messageType: '',
			message: ''
		};

		this.SharedDataService.setData(this.name, dataObject);
	}

	onFocus() {
		this.isFocused = true;
	}

	onBlur() {
		// Timeout pour s'assurer que le clic sur une option est pris en compte avant de masquer le popup
		this.unfocusTimeout = setTimeout(() => {
			this.isFocused = false;
			this.$scope.$apply();
			this.unfocusTimeout = null;
		}, 200);
	}
}
